import styled from 'styled-components';
import BaseIconSvg from '@sdk/components/ui/BaseIconSvg';
import PencilSVG from '@sdk/assets/svg/UI/pencil.svg';
import TrashSVG from '@sdk/assets/svg/UI/trash.svg';

export const EditIcon = styled(BaseIconSvg)``;
EditIcon.defaultProps = { as: PencilSVG };

export const DeleteIcon = styled(BaseIconSvg)``;
DeleteIcon.defaultProps = { as: TrashSVG };

export const ActionButton = styled.button`
  height: 14px;
  border: none;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.iconGray};
`;

export const EditButton = styled(ActionButton)`
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const DeleteButton = styled(ActionButton)`
  &:hover {
    color: ${({ theme }) => theme.colors.danger};
  }
`;
